export function utf16to8(str: string): string {
  let out = '';
  const len = str.length;
  for (let i = 0; i < len; i++) {
    const c = str.charCodeAt(i);
    if (c >= 0x0001 && c <= 0x007f) {
      out += str.charAt(i);
    } else if (c > 0x07ff) {
      out += String.fromCharCode(0xe0 | ((c >> 12) & 0x0f));
      out += String.fromCharCode(0x80 | ((c >> 6) & 0x3f));
      out += String.fromCharCode(0x80 | ((c >> 0) & 0x3f));
    } else {
      out += String.fromCharCode(0xc0 | ((c >> 6) & 0x1f));
      out += String.fromCharCode(0x80 | ((c >> 0) & 0x3f));
    }
  }
  return out;
}

export function utf8to16(str: string): string {
  let out = '';
  const len = str.length;
  let i = 0;
  while (i < len) {
    const c = str.charCodeAt(i);
    i += 1;
    switch (c >> 4) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
        // 0xxxxxxx
        out += str.charAt(i - 1);
        break;
      case 12:
      case 13: {
        // 110x xxxx   10xx xxxx
        const char2 = str.charCodeAt(i);
        i += 1;
        out += String.fromCharCode(((c & 0x1f) << 6) | (char2 & 0x3f));
        break;
      }
      case 14: {
        // 1110 xxxx  10xx xxxx  10xx xxxx
        const char2 = str.charCodeAt(i);
        i += 1;
        const char3 = str.charCodeAt(i);
        i += 1;
        out += String.fromCharCode(
          ((c & 0x0f) << 12) | ((char2 & 0x3f) << 6) | ((char3 & 0x3f) << 0),
        );
        break;
      }
    }
  }

  return out;
}
